// German for the portal-admin ladder — the eight ranked moves and the all-clear line.
import { registerDe } from '../../i18n/index.js';

registerDe({
  // 10 · portal off with a projection behind it
  'The portal is switched off, and there is a projection behind it': 'Das Portal ist ausgeschaltet, und dahinter liegt eine Projektion',
  '{rows} flagged published and {accounts}. With the master switch off every portal call is refused, so an invite sent today lands on a locked door.':
    '{rows} als veröffentlicht markiert und {accounts}. Bei ausgeschaltetem Hauptschalter wird jeder Portalaufruf abgewiesen; eine heute verschickte Einladung landet vor verschlossener Tür.',
  '{n} row is': '{n} Zeile ist',
  '{n} rows are': '{n} Zeilen sind',
  '{n} account exists': '{n} Konto existiert',
  '{n} accounts exist': '{n} Konten existieren',
  'Switch the portal on': 'Portal einschalten',

  // 20 · drafts shared
  '{n} draft statement is in front of the client': '{n} Entwurfsaussage steht vor dem Kunden',
  '{n} draft statements are in front of the client': '{n} Entwurfsaussagen stehen vor dem Kunden',
  '{refs} is still draft in the register and published to the portal. A draft statement shown to a client reads as a commitment.':
    '{refs} ist im Register noch Entwurf und im Portal veröffentlicht. Eine Entwurfsaussage, die ein Kunde sieht, liest sich als Zusage.',
  '{refs} are still draft in the register and published to the portal. A draft statement shown to a client reads as a commitment.':
    '{refs} sind im Register noch Entwurf und im Portal veröffentlicht. Eine Entwurfsaussage, die ein Kunde sieht, liest sich als Zusage.',
  'Stop sharing the drafts': 'Entwürfe nicht mehr teilen',

  // 30 · nothing shared
  'Nothing is shared with {client} yet': 'Mit {client} ist noch nichts geteilt',
  'This engagement has {reqs} and {docs} on record, and none of them is visible to the client. The first decision is which object types the client may see at all.':
    'Dieser Auftrag hat {reqs} und {docs} auf Akte, und nichts davon ist für den Kunden sichtbar. Die erste Entscheidung ist, welche Objekttypen der Kunde überhaupt sehen darf.',
  '{n} requirement': '{n} Anforderung',
  '{n} requirements': '{n} Anforderungen',
  '{n} document': '{n} Dokument',
  '{n} documents': '{n} Dokumente',
  'Choose what they may see': 'Wählen, was sie sehen dürfen',

  // 40 · revised after publish
  '{n} published statement changed after you published it': '{n} veröffentlichte Aussage hat sich nach der Veröffentlichung geändert',
  '{n} published statements changed after you published them': '{n} veröffentlichte Aussagen haben sich nach der Veröffentlichung geändert',
  '{refs} — last publish pass {published}, current revision written {revised}. The client is reading the new text under the old decision.':
    '{refs} — letzter Veröffentlichungslauf {published}, aktuelle Revision geschrieben {revised}. Der Kunde liest den neuen Text unter der alten Entscheidung.',
  'Review what changed': 'Änderungen prüfen',

  // 50 · unanswered comment
  '{who} asked a question {n} day ago': '{who} hat vor {n} Tag eine Frage gestellt',
  '{who} asked a question {n} days ago': '{who} hat vor {n} Tagen eine Frage gestellt',
  'A question has been waiting {n} day': 'Eine Frage wartet seit {n} Tag',
  'A question has been waiting {n} days': 'Eine Frage wartet seit {n} Tagen',
  'On {subject}. Nothing has gone back.': 'Zu {subject}. Es ist nichts zurückgegangen.',
  '{n} more thread is waiting behind it.': '{n} weiterer Thread wartet dahinter.',
  '{n} more threads are waiting behind it.': '{n} weitere Threads warten dahinter.',
  'Answer it': 'Beantworten',

  // 60 · view opens empty
  '{views} would open empty': '{views} würde leer öffnen',
  'and': 'und',
  'The object type is visible, so the tab renders in the client’s navigation, and there is nothing published behind it. An empty tab in a client portal reads as an unfinished system.':
    'Der Objekttyp ist sichtbar, der Tab erscheint also in der Navigation des Kunden, und dahinter ist nichts veröffentlicht. Ein leerer Tab in einem Kundenportal wirkt wie ein unfertiges System.',
  'Hide it or fill it': 'Verbergen oder füllen',

  // 70 · nobody can sign in
  'The portal is on and nobody can sign in': 'Das Portal ist eingeschaltet und niemand kann sich anmelden',
  'No portal account exists for {client}. A portal account can be made from a contact already on the client record, without retyping a name or an address.':
    'Für {client} existiert kein Portalkonto. Ein Portalkonto lässt sich aus einem Kontakt anlegen, der bereits im Kundendatensatz steht — ohne Name oder Adresse neu einzutippen.',
  'Invite from contacts': 'Aus Kontakten einladen',

  // 80 · exclusions published
  '{n} exclusion is published': '{n} Ausschluss ist veröffentlicht',
  '{n} exclusions are published': '{n} Ausschlüsse sind veröffentlicht',
  '{refs}. Showing an exclusion to a client is a contractual statement about what you are not doing — publish it only if you mean to make that point.':
    '{refs}. Einen Ausschluss dem Kunden zu zeigen ist eine vertragliche Aussage darüber, was Sie nicht tun — veröffentlichen Sie ihn nur, wenn Sie genau das sagen wollen.',
  'Check them': 'Prüfen',

  // the all-clear
  'The projection matches the decisions on record. Nothing here needs you.': 'Die Projektion entspricht den Entscheidungen auf Akte. Hier braucht Sie nichts.',
}, 'ladder');
